import React from 'react';

import type { FrapiTeaserItemSized } from '../../../types/frapi-types.js';

import TeaserWrapper from './TeaserWrapper.js';
import Image from './teaserComponents/Image.js';
import Price from '../articles/articleComponents/Price.js';
import { orderTeaserTags } from '../search/helpers.js';
import {
  filterTagsOnType,
  isRestaurantReview,
  isReview,
  makeTagTitle,
} from '../articles/helpers.js';
import { hasPrice } from '../commonComponents/imageUtils.js';

const TeaserSearchResult: React.FC<FrapiTeaserItemSized> = (t) => {
  const isGuide = !isReview(t);
  const guideKicker = t.kicker ? t.kicker : 'Byliv & Guider';
  const description = !isRestaurantReview(t) ? t.lead : t.description;

  const filteredTags = filterTagsOnType(t.tags, [
    'område',
    'type',
    'mattype',
    'strømmetjeneste',
  ]);

  const classNames = ['teaser-info', isGuide ? 'guide' : ''].join(' ');

  return (
    <TeaserWrapper
      classNames="teaser-search-result"
      teaser={t}
      isMobile={t.mobile}
      bundleId={t.bundleId}
    >
      {t.image && (
        <Image
          imageAsset={t.image}
          title={t.title}
          width={100}
          height={202}
          size={t.size}
        />
      )}
      <div className={classNames}>
        <div className="grade-price">
          {t.grade && !isGuide && (
            <div className="front-grade">
              <span className="bold-grade">{t.grade}</span>
              <span>/6</span>
            </div>
          )}
          {hasPrice(t) && isRestaurantReview(t) && (
            <Price price={t.priceLevel} />
          )}
        </div>
        <div className="info-wrapper">
          <div className="kicker">{isGuide ? guideKicker : t.kicker}</div>
          <div className="title">{isGuide ? t.title : description}</div>
        </div>

        <div className="tag-wrapper">
          {orderTeaserTags(filteredTags)
            .slice(0, t.mobile ? 2 : 3)
            .map((tag, i) => (
              <div key={i} className="regular-tag">
                {makeTagTitle(tag.title)}
              </div>
            ))}
        </div>
      </div>
    </TeaserWrapper>
  );
};
export default TeaserSearchResult;
